module.exports = __webpack_public_path__ + "static/media/wheat-main.0ec2c94c.png";